import * as ActionTypes from './types.action';

export const clearErrors = () => ({
  type: ActionTypes.CLEAR_ERRORS,
});
